export enum Indicators {
  GENERAL_INFO = 'GENERAL_INFO',
  LEADS = 'LEADS',
}
